import { render, staticRenderFns } from "./BusinessPaymentEditComponent.vue?vue&type=template&id=3a71e6ac"
import script from "./BusinessPaymentEditComponent.vue?vue&type=script&lang=js"
export * from "./BusinessPaymentEditComponent.vue?vue&type=script&lang=js"
import style0 from "./BusinessPaymentEditComponent.vue?vue&type=style&index=0&id=3a71e6ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports